import { AutoAwesome } from '@mui/icons-material';
import { Box, Button, Card, Stack, Typography } from '@mui/material';
import { RecommendationResult } from './components/recommendation-result';
import {
  useVideoRecommendation,
  VideoRecommendationStatus,
} from './use-video-recommendation';
import { AiChip } from '@/components/shared/ai-chip';

const IdleState = ({ onGenerate }: { onGenerate: () => void }) => (
  <Stack
    direction={{ xs: 'column', md: 'row' }}
    justifyContent="space-between"
    alignItems={{ xs: 'flex-start', md: 'center' }}
    spacing={2}
  >
    <Box>
      <Stack direction="row" spacing={1} alignItems="center" mb={1}>
        <Typography variant="h2">Sua dose diária de desenvolvimento</Typography>
        <AiChip />
      </Stack>
      <Typography>
        Aprenda algo novo todos os dias, com vídeos curtos e personalizados para
        acompanhar o seu momento de carreira.
      </Typography>
    </Box>
    <Button
      variant="contained"
      startIcon={<AutoAwesome />}
      onClick={onGenerate}
      sx={{ flexShrink: 0 }}
    >
      Gerar recomendação
    </Button>
  </Stack>
);

const LoadingState = () => (
  <Stack spacing={1}>
    <Typography variant="h2">
      Aqui está a nossa recomendação diária para você:
    </Typography>
    <Typography color="text.secondary">
      Buscando um vídeo ideal para você...
    </Typography>
  </Stack>
);

export const VideoRecommendationSection = () => {
  const { status, video, textMessage, errorMessage, generate, regenerate } =
    useVideoRecommendation();

  const hasResult =
    status === VideoRecommendationStatus.SuccessVideo ||
    status === VideoRecommendationStatus.SuccessText ||
    status === VideoRecommendationStatus.Error;

  return (
    <Card sx={{ p: 3 }}>
      {status === VideoRecommendationStatus.Idle && (
        <IdleState onGenerate={generate} />
      )}

      {status === VideoRecommendationStatus.Loading && <LoadingState />}

      {hasResult && (
        <RecommendationResult
          status={status}
          video={video}
          textMessage={textMessage}
          errorMessage={errorMessage}
          onRegenerate={regenerate}
        />
      )}
    </Card>
  );
};
